import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  CompanyInternalConfig,
  HttpResponse,
  UpdateCompanyInternalConfigRequest,
} from "@/types";

export const useUpdateSetCompanyInternalConfig = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      updateRequest,
    }: {
      id: string;
      updateRequest: UpdateCompanyInternalConfigRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-internal-configs/${id}`;
      const res = await guacHttpClient.patch<
        CompanyInternalConfig,
        HttpResponse<CompanyInternalConfig>,
        UpdateCompanyInternalConfigRequest
      >(path, updateRequest);

      return res.data;
    },
    onSuccess: (updatedData) => {
      const updatedCompanyInternalConfig = queryClient.setQueryData(
        ["company-internal-configs", currentCompanyId],
        updatedData,
      );

      // The companies summary carries relatedCompanyNames, so refresh it too.
      void queryClient.invalidateQueries({
        queryKey: ["companies-summary"],
      });

      return updatedCompanyInternalConfig;
    },
  });
};
